import {Row, Col, Card, Skeleton} from "antd";
import './Home.css'
import { Pie } from '@ant-design/plots';
import React, { useEffect, useState } from "react";
import {
    getAllDistrictHomeDetails,
    getAllHomeDetails,
    getAllIslandHomeDetails,
    getAllDivisionalDetails,
    
} from "./HomeService";
import { errHandler } from "../../helper/helper";
import jwt_decode from "jwt-decode";
import FullScreenSpinner from "../../Layout/FullScreenSpinner";
import { motion } from 'framer-motion';
import CustomFooter from "../../Layout/CustomFooter";



const createCountData = (data) => {
    let converteData = data.map((post) => {
        return {
            type: post.productName,
            value: post.count
        }

    })
    return converteData;
};
const createAmountData=(data)=>{
    let convertData = data.map((post) => {
            return {
                type: post.product,
                value: post.amount
            }

        })
        return convertData;
    };


const Home = () => {
    const [accountActiveData, setAccountActiveData] = useState([]);
    const [accountDormantData, setAccountDormantData] = useState([]);
    const [loanActiveData, setLoanActiveData] = useState([]);
    const [loanNonActiveData, setLoanNonActiveData] = useState([]);
    const [genderData, setGenderData] = useState([]);
    const [balanceData,setBalanceData] = useState([]);
    const [spinning, setSpinning] = useState(false);



    const token = localStorage.getItem("accessToken")
    const decodeToken = token ? jwt_decode(token) : null;
    const branchId = localStorage.getItem("branchId");
    const loginPlaceId = localStorage.getItem("placeId");
    const districtName = decodeToken.districtName;
    const divstionalID= decodeToken.divAId;



    const configActiveAccount = {
        appendPadding: 10,
        data: accountActiveData,
        angleField: 'value',
        colorField: 'type',
        radius: 0.9,
        label: {
            type: 'outer',
            content: '{percentage}',
        },
        interactions: [
            {
                type: 'pie-legend-active',
            },
            {
                type: 'element-active',
            },
        ],
    };

    const configDormantAccount = {
        appendPadding: 10,
        data: accountDormantData,
        angleField: 'value',
        colorField: 'type',
        radius: 0.9,
        label: {
            type: 'outer',
            content: '{percentage}',
        },
        interactions: [
            {
                type: 'pie-legend-active',
            },
            {
                type: 'element-active',
            },
        ],
    };

    const configActiveLoan = {
        appendPadding: 10,
        data: loanActiveData,
        angleField: 'value',
        colorField: 'type',
        radius: 0.9,
        label: {
            type: 'outer',
            content: ' {percentage}',
        },
        interactions: [
            {
                type: 'pie-legend-active',
            },
            {
                type: 'element-active',
            },
        ],
        // label: {
        //     type: 'inner',
        //     offset: '-30%',
        //     content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
        //     style: {
        //         fontSize: 14,
        //         textAlign: 'center',
        //     },
        // },
        // interactions: [
        //     {
        //         type: 'element-active',
        //     },
        // ],
    };

    const configNonActiveLoan = {
        appendPadding: 10,
        data: loanNonActiveData,
        angleField: 'value',
        colorField: 'type',
        radius: 0.9,
        label: {
            type: 'outer',
            content: '{percentage}',
        },
        interactions: [
            {
                type: 'pie-legend-active',
            },
            {
                type: 'element-active',
            },
        ],
        // label: {
        //     type: 'inner',
        //     offset: '-30%',
        //     content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
        //     style: {
        //         fontSize: 14,
        //         textAlign: 'center',
        //     },
        // },
        // interactions: [
        //     {
        //         type: 'element-active',
        //     },
        // ],
    };

    const configGender = {
        appendPadding: 10,
        data: genderData,
        angleField: 'value',
        colorField: 'type',
        radius: 0.9,
        label: {
            type: 'outer',
            content: '{percentage}',
        },
        interactions: [
            {
                type: 'pie-legend-active',
            },
            {
                type: 'element-active',
            },
        ],
    };

    const configBalance = {
            appendPadding: 10,
            data: balanceData,
            angleField: 'value',
            colorField: 'type',
            radius: 0.9,
            label: {
                type: 'outer',
                content: '{percentage}',
            },
            interactions: [
                {
                    type: 'pie-legend-active',
                },
                {
                    type: 'element-active',
                },
            ],
        };
    const getHomeDetails = () => {
        setSpinning(true);
        getAllHomeDetails(branchId).then((res) => {
            let activeAccountData = createCountData(res.data.activeAccountList);
            setAccountActiveData(activeAccountData);
            let dormantAccountData = createCountData(res.data.dormantAccountList);
            setAccountDormantData(dormantAccountData);
            let activeLoanData = createCountData(res.data.activeLoanList);
            setLoanActiveData(activeLoanData);
            let nonActiveLoanData = createCountData(res.data.nonActiveLoanList);
            setLoanNonActiveData(nonActiveLoanData);
            let genderData = createCountData(res.data.genderList);
            setGenderData(genderData);
            let balanceData=createAmountData(res.data.balanceList);
            setBalanceData(balanceData);
        }).catch((err) => {
            errHandler(err)
        }).finally(()=>{
            setSpinning(false)
        })

    };

    const getHomeDistrictDetails = () => {
        let data = {
            districtName: districtName
        }
        setSpinning(true);
        getAllDistrictHomeDetails(data).then((res) => {
            let activeAccountData = createCountData(res.data.activeAccountList);
            setAccountActiveData(activeAccountData);
            let dormantAccountData = createCountData(res.data.dormantAccountList);
            setAccountDormantData(dormantAccountData);
            let activeLoanData = createCountData(res.data.activeLoanList);
            setLoanActiveData(activeLoanData);
            let nonActiveLoanData = createCountData(res.data.nonActiveLoanList);
            setLoanNonActiveData(nonActiveLoanData)
        }).catch((err) => {
            errHandler(err)
        }).finally(()=>{
            setSpinning(false);
        })

    };

    const getHomeIslandDetails = () => {
        setSpinning(true);
        getAllIslandHomeDetails().then((res) => {
            let activeAccountData = createCountData(res.data.activeAccountList);
            setAccountActiveData(activeAccountData);
            let dormantAccountData = createCountData(res.data.dormantAccountList);
            setAccountDormantData(dormantAccountData);
            let activeLoanData = createCountData(res.data.activeLoanList);
            setLoanActiveData(activeLoanData);
            let nonActiveLoanData = createCountData(res.data.nonActiveLoanList);
            setLoanNonActiveData(nonActiveLoanData)
        }).catch((err) => {
            errHandler(err)
        }).finally(()=>{
            setSpinning(false);
        })

    };
    const getHomeDivisionalDetails = () => {
        setSpinning(true);
        let data={
            divAId:divstionalID
        }
        getAllDivisionalDetails(data).then((res) => {
            let activeAccountData = createCountData(res.data.activeAccountList);
            setAccountActiveData(activeAccountData);
            let dormantAccountData = createCountData(res.data.dormantAccountList);
            setAccountDormantData(dormantAccountData);
            let activeLoanData = createCountData(res.data.activeLoanList);
            setLoanActiveData(activeLoanData);
            let nonActiveLoanData = createCountData(res.data.nonActiveLoanList);
            setLoanNonActiveData(nonActiveLoanData)
        }).catch((err) => {
            errHandler(err)
        }).finally(()=>{
            setSpinning(false);
        })

    };






    useEffect(() => {
        if (loginPlaceId === "1") {
            getHomeDetails();
        } else if (loginPlaceId === "4") {
            getHomeDistrictDetails();
        } else if (loginPlaceId === "3") {
            getHomeIslandDetails();
        }else if (loginPlaceId === "2") {
            getHomeDivisionalDetails();
        }


    }, [])
    return (
        <div className="home-container">
            <div>
                <h3>Home</h3>
            </div>
            {/*<FullScreenSpinner spinning={spinning} />*/}
            <Row gutter={16} title="Customer Statistic" className={`${loginPlaceId === "1" ? '' : 'hidden'}`}>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <Card title="Male and Female Count" className="home-card">
                            {spinning ? (
                                <Skeleton active avatar paragraph={{ rows: 5,width: '100%' }}   style={{ height: '400px' ,alignItems:'center',justifyContent:'center'}}/>
                            ) : (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Pie {...configGender} />
                                </div>
                            )}
                        </Card>
                    </motion.div>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <Card title="Account balance and Loan Total outstanding" className="home-card">
                            {spinning?(
                                <Skeleton active avatar paragraph={{ rows: 5,width: '100%' }}   style={{ height: '400px' }}/>

                            ):(<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Pie {...configBalance} />
                            </div>)}
                        </Card>
                    </motion.div>
                </Col>
            </Row>

            {/* Account Statistic Row */}
            <Row gutter={16} title="Account Statistic" className={`${loginPlaceId === "3" ? 'hidden' : ''}`}>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <Card title="Active Account Count" className="home-card">
                            {spinning?(
                                    <Skeleton active avatar paragraph={{ rows: 5,width: '100%' }}   style={{ height: '400px' }}/>

                                ):
                                (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Pie {...configActiveAccount} />
                            </div>)}
                        </Card>
                    </motion.div>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <Card title="Dormant Account Count" className="home-card">
                            {spinning?(
                                    <Skeleton active avatar paragraph={{ rows: 5,width: '100%' }}   style={{ height: '400px' }}/>

                                ):
                                (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Pie {...configDormantAccount} />
                            </div>)}
                        </Card>
                    </motion.div>
                </Col>
            </Row>

            {/* Loan Statistic Row */}
            <Row gutter={16} title="Loan Statistic" className={`${loginPlaceId === "3" ? 'hidden' : ''}`}>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <Card title="Active Loan Count" className="home-card">
                            {spinning?(
                                    <Skeleton active avatar paragraph={{ rows: 5,width: '100%' }}   style={{ height: '400px' }}/>

                                ):
                                (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Pie {...configActiveLoan} />
                            </div>)}
                        </Card>
                    </motion.div>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                    {loanNonActiveData && (
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1 }}
                        >
                            <Card title="Non Active Loan Count" className="home-card">
                                {spinning?(
                                        <Skeleton active avatar paragraph={{ rows: 5,width: '100%' }}   style={{ height: '400px' }}/>

                                    ):
                                    (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Pie {...configNonActiveLoan} />
                                </div>)}
                            </Card>
                        </motion.div>
                    )}
                </Col>
            </Row>
            <CustomFooter />
        </div>

    );
};
export default Home;